var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "offCanvasLasku" },
    [
      _c("OffCanvasToolbar", {
        attrs: {
          "toolbar-title": _vm.$t("common:offCanvasSopimus.contractInfo"),
          "to-name": "sopimus-nayta",
          "to-id": _vm.value ? _vm.value.id : null,
          "tooltip-title": "sopimus",
        },
        on: {
          "close-button-click": function ($event) {
            return _vm.$emit("close-button-click")
          },
        },
      }),
      _c(
        "v-container",
        { staticClass: "grey lighten-5 px-8" },
        [
          _c("OffCanvasDetailsSopimus", {
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
      _c(
        "v-container",
        { staticClass: "px-8" },
        [
          _c("SopimusYhteenveto", {
            attrs: {
              "title-text": _vm.$t("common:offCanvasSopimus.summaryOfOpen"),
              sopimus: _vm.value,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }